import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useTranslation } from 'react-i18next'

/**
 * ArtistGallery Page
 * Implemented as a practical sample.
 */
export const EmptyGalleryList = () => {
  const { t } = useTranslation('artistGallery')
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '70dvh',
      }}
    >
      <Typography color="primary.main" sx={{ textAlign: 'center' }}>
        {t('postNotExist')}
      </Typography>
    </Box>
  )
}
